import { Controller } from '@hotwired/stimulus'

// A panel on the conversation debug page that fetches its own HTML the first
// time it is opened. Kept separate from `replay`, which owns an interactive
// editor: these panels are read-only once loaded.
export default class extends Controller {
  static targets = ['panel', 'toggle']
  static values = { url: String, loadingLabel: String }

  async toggle() {
    if (!this.loaded) {
      this.loaded = true
      const label = this.hasToggleTarget ? this.toggleTarget.textContent : null
      if (label !== null) this.toggleTarget.textContent = this.loadingLabelValue || 'Carregando...'

      try {
        this.panelTarget.innerHTML = await this._fetchText(this.urlValue)
      } catch (e) {
        const error = document.createElement('p')
        error.className = 'text-sm text-red-600'
        error.textContent = `Falha ao carregar o painel: ${e.message}`
        this.panelTarget.replaceChildren(error)
      } finally {
        if (label !== null) this.toggleTarget.textContent = label
      }
    }

    this.panelTarget.classList.toggle('hidden')
  }

  async _fetchText(url) {
    const response = await fetch(url, {
      headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' },
    })
    if (!response.ok) throw new Error(response.statusText)
    return response.text()
  }
}
